import { useCallback, useState, useMemo } from 'react';
import {
  DateRange,
  initDateRange,
  useHeroSnackbar,
  useTranslations,
  formatDateRanges,
  IDateRangePickerWithTextFieldProps,
} from '@uniqkey-frontend/shared-app';
import { useGetSecurityScoreRate } from '../../../../../../hooks/reactQuery';
import DashboardAverageSecurityScoreWithGraphWidgetContainer
  from '../DashboardAverageSecurityScoreWithGraphWidgetContainer';

const DEFAULT_VALUES = { refreshDate: '', data: [] };

const DashboardAverageSecurityScoreWithGraphWidget = () => {
  const { t } = useTranslations();
  const { showError } = useHeroSnackbar();

  const [range, setRange] = useState<DateRange>(() => initDateRange({
    to: new Date(),
    duration: { day: 7 },
  }));
  const formattedRange = useMemo(
    () => formatDateRanges(range, { asISODate: true, inUTC: false }),
    [range],
  );
  const handleRangeChange = useCallback<
    IDateRangePickerWithTextFieldProps['onSubmit']
  >((newRange) => {
    setRange(newRange);
  }, []);

  const { data: securityScoreRate, isLoading, isError } = useGetSecurityScoreRate(
    { from: formattedRange.from!, to: formattedRange.to! },
    {
      onError: () => {
        showError({ text: t('common.somethingWentWrong') });
      },
      enabled: !!(formattedRange.from && formattedRange.to),
    },
  );

  if (isError) {
    return null;
  }

  const { refreshDate, data } = securityScoreRate ?? DEFAULT_VALUES;

  return (
    <DashboardAverageSecurityScoreWithGraphWidgetContainer
      headerTranslationKey="dashboardAverageSecurityScoreWithGraphWidget.title"
      tooltipTranslationKey="dashboardAverageSecurityScoreWithGraphWidget.tooltip"
      updatedAtTranslationKey="dashboardAverageSecurityScoreWithGraphWidget.updatedAt"
      noDataTranslationKey="dashboardAverageSecurityScoreWithGraphWidget.noData"
      updatedAt={refreshDate}
      from={range.from}
      to={range.to}
      onSubmit={handleRangeChange}
      onClear={handleRangeChange}
      isLoading={isLoading}
      data={data}
    />
  );
};

export default DashboardAverageSecurityScoreWithGraphWidget;
